import React from 'react'
// import { Script } from 'gatsby'
// import staticUrl from '../utils/static-url'

export default function Layout({ children }) {
  return (
    <>
      {children}
      {/* Example global script placed in static/scripts */}
      {/* <Script src={staticUrl('scripts/global.js')} /> */}
    </>
  )
}
